import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DeferRenderingModule } from '../../directives/defer-rendering/defer-rendering.module';
import { ButtonModule } from '../button/button.module';
import { IconicModule } from '../iconic/iconic.module';
import { OverlayModule } from '../overlay/overlay.module';
import {
  ContentTemplate,
  FloatingMenuComponent,
} from './floating-menu.component';

@NgModule({
  imports: [
    CommonModule,
    OverlayModule,
    IconicModule,
    ButtonModule,
    DeferRenderingModule,
  ],
  declarations: [FloatingMenuComponent, ContentTemplate],
  exports: [FloatingMenuComponent, ContentTemplate],
})
export class FloatingMenuModule {}
